<script>
  import UpperPane from "../../../components/chart/UpperPane.svelte";
  import LeftMenuDialog from "../../../components/layout/menuDialog/variants/LeftMenuDialog.svelte";
  import MenuDialogSectionTitle from "../../../components/layout/menuDialog/MenuDialogSectionTitle.svelte";
  import GeneralSelect from "../../../components/select/GeneralSelect.svelte";
  import HelpTooltip from "../../../components/tooltip/HelpTooltip.svelte";
  import MenuDialogSection from "../../../components/layout/menuDialog/MenuDialogSection.svelte";
  import MenuDialogSectionEntry from "../../../components/layout/menuDialog/MenuDialogSectionEntry.svelte";
  import MenuDialogSectionEntryTitle
    from "../../../components/layout/menuDialog/MenuDialogSectionEntryTitle.svelte";
  import GeneralInput from "../../../components/input/GeneralInput.svelte";
  import ChartDisplaySpanSelection from "../../../components/chart/ChartDisplaySpanSelection.svelte";
  import MenuDialogSectionsContainer
    from "../../../components/layout/menuDialog/MenuDialogSectionsContainer.svelte";

  export let store
  const {
    DisplayedSpanInSeconds,
    DisplayedRowCount,
    PSISortOrder,
  } = store

  let MenuDialog = null
  function onClickUpperPaneHamburgerButton() {
    MenuDialog?.showModal()
  }
  function closeMenuDialog() {
    MenuDialog?.close()
  }
</script>

<UpperPane
  store={store}
  onClickHamburgerButton={onClickUpperPaneHamburgerButton}
>
  <LeftMenuDialog
    slot="left-menu-dialog"
    bind:dialog={MenuDialog}
    onClose={closeMenuDialog}
  >
    <MenuDialogSectionsContainer>
      <!-- Section: Display settings -->
      <MenuDialogSection>
        <MenuDialogSectionTitle>
          表示設定
        </MenuDialogSectionTitle>

        <!-- Display span settings -->
        <MenuDialogSectionEntry>
          <MenuDialogSectionEntryTitle>
            表示期間
          </MenuDialogSectionEntryTitle>
          <ChartDisplaySpanSelection
            currentValueInSeconds={$DisplayedSpanInSeconds}
            onChange={(newSpan) => {
            DisplayedSpanInSeconds.set(newSpan);
          }}
          />
        </MenuDialogSectionEntry>

        <!-- Number of rows settings -->
        <MenuDialogSectionEntry>
          <MenuDialogSectionEntryTitle>
            表示数
          </MenuDialogSectionEntryTitle>
          <GeneralInput
            type="number"
            min={1}
            value={$DisplayedRowCount}
            onInput={(e) => {
            const rows = Math.floor(parseInt(e.target.value, 10))
            DisplayedRowCount.set(rows)
          }}
            extraStyle="width: 100%"
          />
        </MenuDialogSectionEntry>

        <MenuDialogSectionEntry>
          <MenuDialogSectionEntryTitle>
            PSIの表示順
            <HelpTooltip title="PSIの表示順">
              PSI表に表示される P: 製造、S: 受注、I: 在庫の表示順を設定します。
            </HelpTooltip>
          </MenuDialogSectionEntryTitle>
          <GeneralSelect
            options={[
              {value: "spi", text: "SPI"},
              {value: "psi", text: "PSI"},
            ]}
            onChangeEvent={(e) => {
              PSISortOrder.set(e.target.value)
            }}
            value={$PSISortOrder}
            extraStyle="width: 100%"
          />
        </MenuDialogSectionEntry>
      </MenuDialogSection>
    </MenuDialogSectionsContainer>
  </LeftMenuDialog>
</UpperPane>
